import React from 'react';

/**
 * PROPS
 * value = string
 * label = string
 * onChange(value) = func
 */

const Checkboxes = props => {

	function setNewValue(c) {
		const newValue = props.value;
		const index = newValue.indexOf(c);
		if (index > -1) {
			newValue.splice(index, 1);
		} else {
			newValue.push(c);
		}
		props.onChange(newValue);
	}

	const values = props.options.map(c => {
		const classes = ['tag'];
		if (props.value.indexOf(c) > -1) classes.push('tag--active');
		return (
			<button
				key={c}
				type="button"
				className={classes.join(' ')}
				onClick={() => setNewValue(c)}
			>
				{c}
			</button>
		);
	});

	return (
		<React.Fragment>
			<p className="txt">{props.label}</p>
			<div className="tags tags--grey tags--sm">{values}</div>
		</React.Fragment>
	);
};

export default Checkboxes;
